import { Resources, useResource } from "Infrastructure/Translations/Resources";
import { Menu } from "Shared/appIcons";
import { PageHeaderBody } from "Shared/Layouts/components/PageHeaderBody";
import type { Breadcrumb } from "Shared/Layouts/components/types";
import { SimpleTooltip } from "Shared/SimpleTooltip";
import type { ReactNode } from "react";
import { Button } from "@/components/ui/button";

type Props = {
	title: string;
	subtitle?: string;
	breadcrumbs?: Breadcrumb[];
	actions?: ReactNode;
	clientSwitcher?: ReactNode;
	onOpenMenu: () => void;
};

/**
 * Hamburger trigger for `DrawerNav` plus the current page header (title,
 * breadcrumbs, actions). Visible only below the `md` breakpoint — on wider
 * viewports `TopbarNav` + `PageHeader` cover the same surface.
 */
export const DrawerTopbar = ({
	title,
	subtitle,
	breadcrumbs,
	actions,
	clientSwitcher,
	onOpenMenu,
}: Props) => {
	const { t } = useResource();

	return (
		<header className="border-border bg-card flex min-h-14 flex-shrink-0 items-center border-b px-4 py-2 md:hidden">
			<SimpleTooltip content={t(Resources.Sidebar.Expand)}>
				<Button
					variant="ghost"
					size="icon-sm"
					onClick={onOpenMenu}
					aria-label={t(Resources.Sidebar.Expand)}
					className="text-muted-foreground hover:text-foreground -ml-1 mr-2"
				>
					<Menu className="h-4 w-4" />
				</Button>
			</SimpleTooltip>
			<PageHeaderBody
				title={title}
				subtitle={subtitle}
				breadcrumbs={breadcrumbs}
				clientSwitcher={clientSwitcher}
			/>
			{actions ? (
				<div className="ml-2 flex flex-shrink-0 items-center gap-1">
					{actions}
				</div>
			) : null}
		</header>
	);
};
